export class MenuOption{
    URL:string ="";
    MenuName:string= "";
    HelpText:string="";
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}